import React, { Fragment } from "react";

const FeatureTwelve2 = () => {
  return (
    <Fragment>
      <div className="block-style-nine color-two">
        <div className="title-style-three pb-10" data-aos="fade-up">
          <div className="sc-title">WHY CHOOSE US</div>
          <h2 className="main-title">
            Why <span>choose us</span> for your business.
          </h2>
        </div>
        {/* /.title-style-three */}
        <ul className="style-none list-item">
          <li data-aos="fade-up">
            Our strong sense of identification with client projects means that
            we are constantly striving to provide solutions, even for issues
            they aren’t yet aware of.
          </li>
          <li data-aos="fade-up" data-aos-delay={100}>
            It’s our attention to the small stuff, scheduling of timelines and
            keen project management that makes us stand out from the rest. We
            are creative, while keeping a close eye on the calendar and your
            budget.
          </li>
          <li data-aos="fade-up" data-aos-delay={200}>
            We bring our diverse background of advertising, design, branding,
            public relations, research and strategic planning to work.
          </li>
        </ul>
      </div>
      {/* /.block-style-nine */}
    </Fragment>
  );
};

export default FeatureTwelve2;
